import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=6645ef0e&scoped=true"
import script from "./EditUserForm.vue?vue&type=script&lang=js"
export * from "./EditUserForm.vue?vue&type=script&lang=js"
import style0 from "./EditUserForm.vue?vue&type=style&index=0&id=6645ef0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645ef0e",
  null
  
)

export default component.exports